import { useState, useEffect, useCallback } from "react";

export default function useDonateRenewCardDeails({ token }) {
  const INVALID = "invalid";
  const LOADING = "loading...";
  const [statusCode, setStatusCode] = useState(null); 
  const [donationDetailsLoaded, setDonationDetailsLoaded] = useState(false);
  const [monthlyDonationDetails, setMonthlyDonationDetails] = useState({
    outbound_token: null,
    outbound_id: null,
    payment_schedule_guid: null,
    name_on_card: LOADING,
    card_type: LOADING,
    card_number: LOADING,
    expiry_date: LOADING,
    amount: LOADING
  });

  const isMonthlyDonationDetailsValid = useCallback(() => {
    return (
      monthlyDonationDetails.outbound_token !== null &&
      monthlyDonationDetails.outbound_id !== null &&
      monthlyDonationDetails.payment_schedule_guid !== null &&
      monthlyDonationDetails.name_on_card !== INVALID &&
      monthlyDonationDetails.card_type !== INVALID &&
      monthlyDonationDetails.card_number !== INVALID &&
      monthlyDonationDetails.expiry_date !== INVALID &&
      monthlyDonationDetails.amount !== INVALID
    );
  }, [monthlyDonationDetails]);

  useEffect(function loadDonationDetails() {
    if (donationDetailsLoaded) return;
    if (!token) {
      setMonthlyDonationDetails({
        outbound_token: null,
        outbound_id: null,
        payment_schedule_guid: null,
        name_on_card: INVALID,
        card_type: INVALID,
        card_number: INVALID,
        expiry_date: INVALID,
        amount: INVALID
      });
      return;
    }

    fetch(`${process.env.GATSBY_FORM_ENDPOINT}/card/details`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.code) {
          setStatusCode(res.code);
        }
        if (res.status !== "success") {
          setMonthlyDonationDetails({
            outbound_token: null,
            outbound_id: null,
            payment_schedule_guid: null,
            name_on_card: INVALID,
            card_type: INVALID,
            card_number: INVALID,
            expiry_date: INVALID,
            amount: INVALID
          });
        } else {
          const data = res.data;
          setMonthlyDonationDetails({
            outbound_token: token,
            outbound_id: data.outbound_id,
            payment_schedule_guid: data.payment_schedule_guid,
            name_on_card: data.name_on_card,
            card_type: data.card_type,
            card_number: data.card_number,
            expiry_date: data.expiry_date,
            amount: data.amount
          });
        }
        setDonationDetailsLoaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [monthlyDonationDetails, isMonthlyDonationDetailsValid, statusCode];
}
